require('./bootstrap');
ClipboardJS=require('clipboard');
